/* Modulo: Compare Story — draggable before/after seam.
   Vanilla IIFE. No moduloLazyInit (extension-only); sections roll their own init
   and re-fire on shopify:section:load for the theme editor. Reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  function initSection(el) {
    if (!el || el.dataset.cstReady === '1') return;
    var frame = el.querySelector('[data-cst-frame]');
    var handle = el.querySelector('[data-cst-handle]');
    if (!frame || !handle) return;
    el.dataset.cstReady = '1';

    var pos = parseFloat(el.getAttribute('data-initial'));
    if (isNaN(pos)) pos = 50;
    var clickToJump = el.getAttribute('data-click-to-jump') === 'true';
    var enableIntro = el.getAttribute('data-intro') === 'true';
    var dragging = false;
    var touched = false;

    function render() {
      el.style.setProperty('--modulo-cst-pos', pos);
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }
    render();

    function pct(e) {
      var r = frame.getBoundingClientRect();
      if (!r.width) return pos;
      return clamp((e.clientX - r.left) / r.width * 100, 0, 100);
    }
    function mark() { touched = true; handle.classList.remove('is-nudging'); }

    function onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      // Drag always starts from the handle; the rest of the frame only jumps
      // when click-to-jump is enabled.
      if (e.target === handle || handle.contains(e.target) || clickToJump) {
        dragging = true;
        mark();
        try { frame.setPointerCapture(e.pointerId); } catch (_) {}
        pos = pct(e);
        render();
      }
    }
    function onMove(e) { if (dragging) { pos = pct(e); render(); } }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      try { frame.releasePointerCapture(e.pointerId); } catch (_) {}
    }

    frame.addEventListener('pointerdown', onDown);
    frame.addEventListener('pointermove', onMove);
    frame.addEventListener('pointerup', onUp);
    frame.addEventListener('pointercancel', onUp);

    handle.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 5;
      var handled = true;
      switch (e.key) {
        case 'ArrowLeft': case 'ArrowDown': pos = clamp(pos - step, 0, 100); break;
        case 'ArrowRight': case 'ArrowUp': pos = clamp(pos + step, 0, 100); break;
        case 'Home': pos = 0; break;
        case 'End': pos = 100; break;
        default: handled = false;
      }
      if (handled) { e.preventDefault(); mark(); render(); }
    });
    handle.addEventListener('focus', mark);

    if (enableIntro && !REDUCE) {
      window.setTimeout(function () {
        if (!touched) handle.classList.add('is-nudging');
      }, 700);
    }
  }

  function bootstrap(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('[data-modulo-cst]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(document); });
  } else {
    bootstrap(document);
  }

  // Theme editor: re-init the reloaded section.
  document.addEventListener('shopify:section:load', function (e) {
    bootstrap(e.target || document);
  });
})();
